import { Injectable } from '@angular/core';
import {CrudService} from './crud/interfaces/crud-service.interface';
import {GiftCard, GiftCardBrand, Order, Referral} from '../dto/order';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataListModel} from '../models/data-list-model';
import {toServerDateString} from '../providers/app-date-adapter';
import {AnnualFee} from '../dto/annualFee';
import {AnnualFeeDeduction} from "../dto/invoice";

@Injectable({
  providedIn: 'root'
})
export class AnnualFeeService implements CrudService<AnnualFee> {

  readonly apiPath = 'annual-fee/';

  constructor(private http: HttpClient) { }
  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<AnnualFee>;
  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string},
    companiesFilter?: string[],
    additionalField1?: string,
    additionalField2?: string,
    additionalValue1?: string,
    additionalValue2?: string,
    identStatusFilter?: string[],
    productsFilter?: string[],
    cardStatusFilter?: string[],


  ): Observable<DataListModel<AnnualFee>> {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('startFilterDate', toServerDateString(startFilterDate))
      .set('endFilterDate', toServerDateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData)
      .set('additionalField1', additionalField1)
      .set('additionalValue1', additionalValue1)
    ;

  if (companiesFilter instanceof Array) {
    companiesFilter.forEach(element => {
      params = params.append('companiesFilter', element);
    });
  }

  if (productsFilter instanceof Array) {
    productsFilter.forEach(element => {
      params = params.append('productsFilter', element);
    });
  }

  if (cardStatusFilter instanceof Array) {
    cardStatusFilter.forEach(element => {
      params = params.append('cardStatusFilter', element);
    });
  }

  if (dateFilterCols instanceof Array) {
    dateFilterCols.forEach(element => {
      params = params.append('dateFilterCols', element);
    });
  }
  if (additionalFilterData instanceof Array) {
    additionalFilterData.forEach(element => {
      params = params.append('additionalFilterData', element);
    });
  }
  if (enumFilter) {
    params = params.append('enumFilter', JSON.stringify(enumFilter));
  }

  return this.http.get(this.apiPath, { params }) as Observable<DataListModel<AnnualFee>>;

}
  add(item: AnnualFee): Observable<any> {
    throw new Error('Method not implemented.');
  }
  update(item: Order) {
    return this.http.put(this.apiPath, item) as Observable<AnnualFee>;
  }

  getDueCount(): Observable<number> {
    return this.http.get(this.apiPath + 'due-count') as Observable<number>;
  }

  deleteMany(idList: any[]) {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, { params: httpParams });
  }

  restoreMany(idList: any[]) {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPath, null, { params: httpParams });
  }

  delete(id: any) {
    return this.deleteMany([id]);
  }

  restore(id: any) {
    return this.restoreMany([id]);
  }

  getByCustomerId( customerId: number ): Observable<AnnualFee[]> {

    const params = new HttpParams()
      .set('customerId', customerId)
    ;
    return this.http.get(this.apiPath+'by-customer-id', {params}) as Observable<AnnualFee[]>;
  }

}
